import { useNavigate, useParams } from "react-router-dom";
import HomeHeader from "../HeaderLayouts/HomeHeader";
import {
    CheckCircleIcon,
    XCircleIcon,
    TicketIcon,
    PhoneIcon,
    CalendarIcon,
    ClockIcon,
    UserIcon,
} from "@heroicons/react/outline";
import { useQrcodeReceiptVerificatonQuery } from "../Features/ticketsSlice";
import Logo from "./Logo";

function TicketVerificationView() {
    const { ticket_number } = useParams();
    const navigate = useNavigate();

    const {
        data: receiptDetails,
        isLoading,
        isSuccess,
        } = useQrcodeReceiptVerificatonQuery(ticket_number)


    const valid = (receiptDetails?.data?.cancelled)? 0 : 1;

return (
    <div className="min-h-screen bg-gray-100">
              <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="flex items-center justify-between h-16">

            {/* Logo */}
            <button
              type="button"
              onClick={() => navigate("/")}
              className="flex items-center focus:outline-none"
              aria-label="Go to home"
            >
              <Logo />
            </button>
          </div>

        </div>

      </header>
        <div className="flex justify-center px-3 py-5 sm:px-4 sm:py-8">
            <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg px-4 py-5 sm:px-6 sm:py-6">

                {/* ================= STATUS ================= */}
                <div className="flex flex-col items-center text-center">

                    <div
                        className={`w-20 h-20 sm:w-24 sm:h-24 rounded-full flex items-center justify-center ${
                            valid
                                ? "bg-green-100"
                                : "bg-red-100"
                        }`}
                    >
                        {valid ? (
                            <CheckCircleIcon
                                className="w-12 h-12 sm:w-16 sm:h-16 text-green-600"
                            />
                        ) : (
                            <XCircleIcon
                                className="w-12 h-12 sm:w-16 sm:h-16 text-red-600"
                            />
                        )}
                    </div>

                    <h1
                        className={`mt-3 text-xl sm:text-2xl font-bold font-mono ${
                            valid
                                ? "text-green-600"
                                : "text-red-600"
                        }`}
                    >
                        {valid ? "VALID TICKET" : "INVALID TICKET"}
                    </h1>

                    <p className="text-lg sm:text-xl font-mono tracking-widest text-gray-900 dark:text-white">
                        {receiptDetails?.data?.business_name}
                    </p>
                </div>


                {receiptDetails && (
                    <div className="mt-7 font-mono text-xs sm:text-sm text-gray-800">

                        {/* ================= TICKET NUMBER ================= */}
                        <div className="text-center border-b border-dashed border-gray-400 pb-5">

                            <p className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-widest">
                                Ticket Number
                            </p>

                            <p className="mt-2 text-2xl sm:text-3xl font-bold tracking-widest break-all">
                                {receiptDetails.data.ticket_token}
                            </p>

                        </div>


                        {/* ================= DETAILS ================= */}
                        <div className="mt-5">

                            <div className="text-center font-bold uppercase mb-4 tracking-wide">
                                Receipt Details
                            </div>

                            <div className="space-y-2">

                                <ReceiptRow
                                    label="Passenger:"
                                    value={receiptDetails.data.full_name}
                                />

                                <ReceiptRow
                                    label="Phone No:"
                                    value={receiptDetails.data.phone}
                                />

                                <ReceiptRow
                                    label="Route:"
                                    value={receiptDetails.data.route_name}
                                />

                                <ReceiptRow
                                    label="Departure Date:"
                                    value={receiptDetails.data.departure_date}
                                />

                                <ReceiptRow
                                    label="Departure Time:"
                                    value={receiptDetails.data.departure_time}
                                />

                                <ReceiptRow
                                    label="Seat No:"
                                    value={receiptDetails.data.seat_number || "—"}
                                />

                                <ReceiptRow
                                    label="Payment Type:"
                                    value={receiptDetails.data.payment_type_name}
                                />

                                <ReceiptRow
                                    label="Created At:"
                                    value={receiptDetails.data.created_at}
                                />

                                {/* ================= TOTAL ================= */}
                                <div className="border-t border-dashed border-gray-400 my-4"></div>

                                <div className="flex justify-between items-center gap-4">
                                    <span className="text-gray-500 shrink-0">
                                        Amount:
                                    </span>

                                    <span className="font-bold text-base sm:text-lg text-right">
                                        K {Number(
                                            receiptDetails.data.price || 0
                                        ).toFixed(2)}
                                    </span>
                                </div>

                                {/* STATUS */}
                                <div className="flex justify-between items-center gap-4 mt-2">
                                    <span className="text-gray-500 shrink-0">
                                        Status:
                                    </span>

                                    <span
                                        className={`font-bold ${
                                            valid
                                                ? "text-green-600"
                                                : "text-red-600"
                                        }`}
                                    >
                                        {valid ? "Valid" : "Invalid"}
                                    </span>
                                </div>

                                <div className="border-t border-dashed border-gray-400 my-4"></div>

                                {/* TICKET */}
                                <ReceiptRow
                                    label="Ticket No:"
                                    value={receiptDetails.data.ticket_token}
                                />

                            </div>
                        </div>

                    </div>
                )}

            </div>
        </div>
    </div>
);


function ReceiptRow({ label, value }) {
    return (
        <div className="flex items-start justify-between gap-3 py-1">

            {/* Label */}
            <span className="text-gray-500 shrink-0">
                {label}
            </span>

            {/* Value */}
            <span className="text-right font-medium break-words min-w-0 max-w-[65%]">
                {value || "—"}
            </span>

        </div>
    );
}
}

export default TicketVerificationView;